import{createModalContext}from"../modal";export const[DepositModalProvider,useDepositModalView,useDepositModalActions]=createModalContext('Deposit');